/**
 * Labstep
 *
 * @module grid/SmartTableProtocolCondition/components/ToolPanel/ProtocolValue
 * @desc Hardcoded list of columns for experiment fields
 */

import { ActionComponent } from 'labstep-web/core/Action/Component';
import { Flex } from 'labstep-web/core/Flex';
import { Header } from 'labstep-web/core/Header';
import { useToolPanelContext } from 'labstep-web/grid/Index/components/ToolPanel/context';
import { ToolPanelState } from 'labstep-web/grid/SmartTableProtocolCondition/components/ToolPanel';
import { ProtocolValueAddColumns } from 'labstep-web/grid/SmartTableProtocolCondition/components/ToolPanel/ProtocolValue/AddColumns';
import type React from 'react';
import type { IEntityDataGridToolPanelProtocolValueProps } from './types';

export const EntityDataGridToolPanelProtocolValue: React.FC<
  IEntityDataGridToolPanelProtocolValueProps
> = ({
  entityView,
  gridSmartTableProtocolConditionService,
  protocolValue,
  colIds,
  experimentOrProtocol,
  selectMetadata,
  setProtocolValue,
}) => {
  if (!protocolValue.reportingName) {
    return null;
  }

  const toolPanelContext = useToolPanelContext();

  return (
    <div>
      <Flex vAlignContent="center" spacing="gap" shrink={0}>
        <ActionComponent
          type="icon"
          icon="arrow left"
          text="Go Back"
          onClick={() =>
            toolPanelContext?.setToolPanelState(
              ToolPanelState.add_column,
            )
          }
        />
        <Header size="tiny" noMargin>
          Add Column for {protocolValue.name}
        </Header>
      </Flex>
      <ProtocolValueAddColumns
        protocolValue={protocolValue}
        entityView={entityView}
        gridSmartTableProtocolConditionService={
          gridSmartTableProtocolConditionService
        }
        colIds={colIds}
        experimentOrProtocol={experimentOrProtocol}
        selectMetadata={selectMetadata}
        setProtocolValue={setProtocolValue}
      />
    </div>
  );
};
